module.exports = __webpack_public_path__ + "img/Wallet-screenshot.4c5b19d9.jpg";